import { render, staticRenderFns } from "./OverseaGraduateReportPage.vue?vue&type=template&id=719125b3&scoped=true"
import script from "./OverseaGraduateReportPage.vue?vue&type=script&lang=js"
export * from "./OverseaGraduateReportPage.vue?vue&type=script&lang=js"
import style0 from "./OverseaGraduateReportPage.vue?vue&type=style&index=0&id=719125b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719125b3",
  null
  
)

export default component.exports